import { Fragment } from "react";
import Accessories from "./Accessories/Accessories";
import OurPartners from "./ourPartners";
import "../home/style.scss";
import "../home/Products/style.scss";
import Products from "./Products";
import BannerSlider from "./bannerSlider/BannerSlider";
import MetaInformation from "../../utils/meta/MetaInformation";
import vedio from "../../assets/files/vid.mp4";
import ReactPlayer from "react-player";

const whoWeAreImage = require("../../assets/images/whoWeAre.png");

function Home() {
  return (
    <Fragment>
      <MetaInformation
        title="HERZMANN"
        name="HERZMANN Home route"
        content="HERZMANN - Products - Accessories - Partners"
      />
      <BannerSlider />

      {/*Section:  Who we are */}
      <div>
        <div className="bg-who-we-are p-3 p-md-5">
          <div className="d-flex justify-content-center flex-column flex-md-row gap-3 gap-lg-5 my-5">
            <div className="col-12 col-md-5">
              <span
                className="d-flex justify-content-center align-items-center player-wrapper"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <ReactPlayer url={vedio} playing={true} loop={true} controls={true} muted={true}  className="react-player" />
              </span>
            </div>
            <div className="col-12 col-md-5 who-we-are-text text-justify">
              <span
                // className="d-flex align-items-center"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                <h2 className="who-we-are-heading mb-3 text-white">
                  Who We Are
                </h2>

                <p className="who-we-are-p">
                  Herzmann is a designer, developer and manufacturer of modular
                  operating theaters and laboratory furniture. Our range of
                  complete accessories offers our customers conflict-free
                  complete solutions.We use a design validation process that
                  ensures a minimum of on-site work. Our patented system takes
                  tolerances into account, simplifies installation and ensures a
                  near-perfect final finish.
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* section: Poroducts */}

      <div id="products">
        <Products />
      </div>

      <Accessories />

      {/*section: partners */}
      <div className="container mt-5 mb-5">
        <h2 className="partners-heading m-0">Our Partners</h2>

        <div className="row mt-5 d-flex justify-content-around">
          <OurPartners />
        </div>
      </div>
    </Fragment>
  );
}

export default Home;
